import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { MarketoLightbox } from '../../../molecules/marketo-lightbox/js/marketo-lightbox';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import { SapCdcLightbox } from '../../sapcdc-lightbox/js/sapcdc-lightbox';

const classes = {
	lightboxComponent: "js-m-marketo-lightbox-component",
	SapCdclightboxComponent : "js-m-form-lightbox-component"
}

const moduleName = "CampaignDownload";
@createModule('CampaignDownload')
export class CampaignDownload extends TerrificSpec {
	$ctx: JQuery;
	autoDownload: boolean;
	downloadLink: string;
	flowId: string;
	noActionForKnownUsers: boolean;
	closeButtonDisabled: boolean;
	themeAttribute: string;
	formFlowId: string;
	formcloseButtonDisabled: boolean;
	formthemeAttribute: string;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this.autoDownload = this.$ctx.data("auto-download");
		this.downloadLink = this.$ctx.data("download-url");
		this.flowId = this.$ctx.data("mkto-flowid");
		this.noActionForKnownUsers = this.$ctx.data("no-action");
		this.closeButtonDisabled = this.$ctx.data("mktoflow-close-disabled");
		this.themeAttribute = this.$ctx.data("mkto-themeattribute");
		this.flowId = this.$ctx.data("form-flowid");
		this.formcloseButtonDisabled = this.$ctx.data("formflow-close-disabled");
		this.formthemeAttribute = this.$ctx.data("form-themeattribute");

		if (this.autoDownload) {
			if (this.flowId != undefined) {
				if (this.flowId.length > 0) {
					if (!Track.isKnownMarketoLead()) {
						let lightboxComponent = $("html").find(`.${classes.lightboxComponent}`);
						if (lightboxComponent.length > 0) {
							let lightbox = getModuleByDomNode(lightboxComponent[0]) as MarketoLightbox;
							lightbox.start(resolve);
							lightbox.getMktoLightboxView(this.flowId, this.downloadLink, this.closeButtonDisabled, this.themeAttribute);
						}
						else {
							console.log(`${moduleName}, lightboxComponent doesn't exist on current page.`);
						}
					}
					else if (Track.isKnownMarketoLead() && !this.noActionForKnownUsers) {
						window.location.href = this.downloadLink;
					}
					else {
						console.log(`${moduleName}, known user: ${Track.isKnownMarketoLead()}, no action: ${this.noActionForKnownUsers}`);
					}
				}
			}
			else if (this.formFlowId != undefined)
			{
				if (this.formFlowId.length > 0) {
					if (!Track.isKnownCdcLead()) {
						let lightboxComponent = $("html").find(`.${classes.SapCdclightboxComponent}`);
						if (lightboxComponent.length > 0) {
							let lightbox = getModuleByDomNode(lightboxComponent[0]) as SapCdcLightbox;
							lightbox.start(resolve);
							lightbox.getCdcLightboxView(this.formFlowId, this.downloadLink, this.formcloseButtonDisabled, this.formthemeAttribute);
						}
						else {
							console.log(`${moduleName}, SapCdc lightboxComponent doesn't exist on current page.`);
						}
					}
					else if (Track.isKnownCdcLead() && !this.noActionForKnownUsers) {
						window.location.href = this.downloadLink;
					}
					else {
						console.log(`${moduleName}, known user: ${Track.isKnownCdcLead()}, no action: ${this.noActionForKnownUsers}`);
					}
				}

			}
		}
		resolve();
	}
	stop() { }
}
